import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { sharedDefaultProps, sharedPropTypes } from '../utilities';
import { PaginationStepControl, PaginationListItem } from '../Controls';

var propTypes = _objectSpread(_objectSpread({}, sharedPropTypes), {}, {
  children: PropTypes.node
});

var defaultProps = _objectSpread(_objectSpread({}, sharedDefaultProps), {}, {
  children: null
});
/**
 * @ignore
 */


var PaginationControls = function PaginationControls(props) {
  var baseUrl = props.baseUrl,
      children = props.children,
      selectedPage = props.selectedPage,
      selectPage = props.selectPage,
      total = props.total,
      dataTrack = props.dataTrack,
      level = props.level,
      position = props.position,
      cta = props.cta,
      surface = props.surface,
      focusBorderRadius = props.focusBorderRadius;

  function _selected(page) {
    selectPage(page);
  }

  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(PaginationListItem, {
    marginSide: 'right'
  }, /*#__PURE__*/React.createElement(PaginationStepControl, {
    direction: "previous",
    baseUrl: baseUrl,
    selectedPage: selectedPage,
    total: total,
    onClick: _selected,
    tabIndex: 0,
    cta: cta,
    position: position,
    level: level,
    dataTrack: dataTrack,
    surface: surface,
    focusBorderRadius: focusBorderRadius
  })), children, /*#__PURE__*/React.createElement(PaginationListItem, {
    marginSide: 'left'
  }, /*#__PURE__*/React.createElement(PaginationStepControl, {
    direction: "next",
    baseUrl: baseUrl,
    selectedPage: selectedPage,
    total: total,
    onClick: _selected,
    tabIndex: 0,
    cta: cta,
    position: position,
    level: level,
    dataTrack: dataTrack,
    surface: surface,
    focusBorderRadius: focusBorderRadius
  })));
};

PaginationControls.propTypes = propTypes;
PaginationControls.defaultProps = defaultProps;
export default PaginationControls;